<h5 class="my-3">Stats</h5>

@if (!loadingStats) {
  <div class="row my-2">
    <div class="col-8">
      <label>CLAIMS</label>
    </div>
    <div class="col-4">
      {{ clientStats.claimCount | number }}
    </div>
  </div>
  <div class="row my-2">
    <div class="col-8">
      <label>REFERRALS</label>
    </div>
    <div class="col-4">
      {{ clientStats.referralCount | number }}
    </div>
  </div>
  <div class="row my-2">
    <div class="col-8">
      <label>ENCOUNTERS</label>
    </div>
    <div class="col-4">
      {{ clientStats.encounterCount | number }}
    </div>
  </div>
  <div class="row my-2">
    <div class="col-8">
      <label>PATIENTS</label>
    </div>
    <div class="col-4">
      {{ clientStats.patientCount | number }}
    </div>
  </div>
  <div class="row my-2">
    <div class="col-8">
      <label>PATIENT MATCHES</label>
    </div>
    <div class="col-4">
      {{ clientStats.patientMatchesCount | number }}
    </div>
  </div>
  <div class="row my-2">
    <div class="col-8">
      <label>NEW TASK EMAIL</label>
    </div>
    <div class="col-4">
      {{ client.newTaskAndLocationsEmailSentAt | date:'MM/dd/yyyy' }}
    </div>
  </div>
  <div class="row my-2">
    <div class="col-8">
      <label>EXPIRING TASK EMAIL</label>
    </div>
    <div class="col-4">
      {{ client.expiringTaskEmailSentAt | date:'MM/dd/yyyy' }}
    </div>
  </div>
} @else {
  <div class="mb-3"><mat-spinner [diameter]="30" /></div>
}

<h5 class="my-3">Claim Sources</h5>

@if (!loadingMetrics) {
  @for (source of this.programMetrics.claimSourceActivity | keyvalue; track source.key) {
    <div class="row my-2">
      <div class="col-8">
        <label>{{ source.key.toUpperCase() }}</label>
      </div>
      <div class="col-4">
        {{ source.value | date:'MM/dd/yyyy' }}
      </div>
    </div>
  }
} @else {
  <div class="mb-3"><mat-spinner [diameter]="30" /></div>
}
